import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Modal,
} from "react-bootstrap";
import "./index.scss";
import { useCart } from "../../context/CartContext";
import Header from "../../components/appLayout/header";
import first from "../../assets/images/first.png";
import { useClientAuth } from "../../context/ClientAuthContext";
import img from "../../assets/images/favourite.gif";
const Checkout = () => {
  const { cartItems, total, clearCart } = useCart();
  const deliveryFee = 8.0;
  const freeDeliveryThreshold = 150.0;
  const { currentClient } = useClientAuth();
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [message, setMessage] = useState(null);
  const [showModal, setShowModal] = useState(false); // ✅ état du modal

  const progressValue = Math.min((total / freeDeliveryThreshold) * 100, 100);

  const applyPromo = async () => {
    try {
      const response = await fetch(
        `https://api.almasecret.msit-demo.fr/promos/promo/validate?code=${promoCode}`
      );
      if (!response.ok) throw new Error("Code promo invalide ou expiré");
      const data = await response.json();
      setDiscount(data.discountPercentage);
      setMessage({ type: "success", text: data.message });
    } catch (err) {
      setDiscount(0);
      setMessage({ type: "danger", text: err.message });
    }
  };

  const discountAmount = (total * discount) / 100;
  const isFreeDelivery = total - discountAmount >= freeDeliveryThreshold;
  const totalAfterDiscount =
    total - discountAmount + (isFreeDelivery ? 0 : deliveryFee);

  const createOrder = async () => {
    try {
      const address = currentClient
        ? JSON.parse(localStorage.getItem("clientAdresse") || "{}")
        : JSON.parse(localStorage.getItem("guestAdresse") || "{}");

      if (!address || Object.keys(address).length === 0) {
        setMessage({
          type: "danger",
          text: "Adresse de livraison introuvable.",
        });
        return;
      }

      const products = cartItems.map((item) => ({
        _id: item._id,
        title: item.title,
        price: item.price,
        quantity: item.quantity,
      }));

      const orderPayload = {
        products,
        codePostal: address.codePostal,
        lieu: address.lieu,
        nom: address.nom,
        prenom: address.prenom,
        numero: address.numero,
        ville: address.ville,
        userId: currentClient ? currentClient.userId : undefined,
        total: totalAfterDiscount,
        promoCode: promoCode || undefined,
        totalA: total,
      };

      // 4️⃣ Envoyer la commande à l'API
      const response = await fetch("https://api.almasecret.msit-demo.fr/orders", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderPayload),
      });

      if (!response.ok)
        throw new Error("Erreur lors de la création de la commande");
      const data = await response.json();
      setShowModal(true); // ✅ Affiche le modal
      clearCart();
    } catch (err) {
      setMessage({ type: "danger", text: err.message });
    }
  };

  return (
    <>
      <div className="p-md-5 p-0 pt-md-3">
        <Header />
      </div>
      <Container className="checkout-section">
        <Row>
          <Col md={12}>
            <div className="checkout-box">
              <h6 className="checkout-title">MODE DE LIVRAISON</h6>
              <div className="d-flex justify-content-between">
                <span className="span-text">Livraison express à domicile</span>
                <span className="prix-span">{deliveryFee.toFixed(3)} DT</span>
              </div>
              <div className="progress-info">
                <p>
                  🚚 Ajoutez{" "}
                  <strong>
                    {(freeDeliveryThreshold - total).toFixed(3)} DT
                  </strong>{" "}
                  pour <strong>la livraison gratuite</strong>
                </p>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progressValue}%` }}
                  />
                </div>
                <div className="d-flex justify-content-between small-f ">
                  <span>{total.toFixed(3)} DT</span>
                  <span>{freeDeliveryThreshold.toFixed(3)} DT</span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center">
                <button className="mt-5 btn-cont">CONTINUEZ MES ACHATS</button>
              </div>
              <div className="mt-5">
                <h6 className="checkout-title">NOS PARTENAIRES DE LIVRAISON</h6>
                <img src={first} alt="First Delivery" />
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-5">
          {/* SECTION GAUCHE */}
          <Col md={8}>
            <div className="checkout-box mt-3">
              <h6 className="checkout-title">PAIEMENT</h6>
              <div className="d-flex align-items-center mt-4">
                <Form.Check type="radio" defaultChecked />
                <span className="ms-2 text-liv">Paiement à la livraison</span>
              </div>
              <small className="text-muted-1 ms-4 mb-4">
                Payez en espèces lors de la réception de votre commande
              </small>
            </div>
          </Col>

          {/* SECTION DROITE */}
          <Col md={4}>
            <div className="checkout-summary mt-3">
              <h6 className="checkout-title">PRODUITS</h6>
              {cartItems.map((item) => (
                <div
                  key={item.id}
                  className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="checkout-product-img"
                    />
                    <div className="ms-2">
                      <p className="mb-0">{item.name}</p>
                      <small>
                        {item.price.toLocaleString()} DT x {item.quantity}
                      </small>
                    </div>
                  </div>
                  <div>
                    <strong>
                      {(item.price * item.quantity).toLocaleString()} DT
                    </strong>
                  </div>
                </div>
              ))}

              {/* Code promo */}
              <div className="d-flex gap-2 my-3">
                <Form.Control
                  type="text"
                  placeholder="Appliquez le code promo"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                />
                <Button variant="outline-dark" onClick={applyPromo}>
                  Appliquer
                </Button>
              </div>

              {message && <Alert variant={message.type}>{message.text}</Alert>}

              {/* Détails du total */}
              {discount > 0 && (
                <div className="d-flex justify-content-between">
                  <span>Réduction ({discount}%)</span>
                  <strong>-{discountAmount.toFixed(3)} DT</strong>
                </div>
              )}

              <div className="d-flex justify-content-between border-top pt-2">
                <span>Total</span>
                <strong>{totalAfterDiscount.toFixed(3)} DT</strong>
              </div>

              <Button
                className="w-100 mt-3"
                variant="dark"
                onClick={createOrder}>
                CONFIRMER LA COMMANDE
              </Button>
            </div>
          </Col>
        </Row>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          className="custom-modal">
          <div className="d-flex align-items-center  justify-content-center flex-column p-5">
            {" "}
            <img src={img} />
            <h1 className="title-modal">
              achat efféctué <br />
              avec succés.
            </h1>
            <button
              className="btn-modal mt-5"
              onClick={() => (window.location.href = "/all-products")}>
              tous les produits
            </button>
          </div>
        </Modal>
      </Container>
    </>
  );
};

export default Checkout;
